import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input } from '@netexknowledge/smart-components';

export default class SearchArea extends Component {
  state = {
    query: ''
  };

  onChange = e => {
    this.setState({ query: e.target.value });
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.props.onSubmit(this.state.query);
    }
  };

  render() {
    const { placeholderText, id } = this.props;
    const { query } = this.state;

    return (
      <Input
        id={id}
        type="text"
        placeholder={placeholderText}
        value={query}
        onChange={this.onChange}
        onKeyPress={this.handleKeyPress}
      />
    );
  }
}

SearchArea.propTypes = {
  placeholderText: PropTypes.string,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string
};

SearchArea.defaultProps = {
  placeholderText: '',
  onSubmit: text => console.log('Event onSubmit', text),
  style: ''
};
